import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { TimeReportingProjectFormTypes } from "models/formTypes";
import { FormFieldConstants } from "utils/constants";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
//#endregion
//#region components
import useTimeReportingProjectReportFilterDefinition from "./forms/useTimeReportingProjectReportFilterDefinition";
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReportSearchInput,
  SearchContextProvider,
  StyledButton,
} from "components/common";
import { Grid } from "@mui/material";
import TimeReportingProjectsList from "./timeReportingProjectsList";
import { useTimeReportingProjectService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { useNavigate, useLocation } from "react-router-dom";
import { CompanyService } from "services";

const TimeReportingProjectReport: React.FC = (props) => {
  const timeReportingProjectService = useTimeReportingProjectService();
  const location = useLocation();
  const navigate = useNavigate();

  const onTimeReportingProjectsCreateClick = () => {
    navigate(UrlHelper.formatPath(`/Projects/Create`), {
      state: { background: location, preserveSearch: true },
    });
  };

  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useTimeReportingProjectReportFilterDefinition();

  const getTopRightButtons = () => {
    let buttons: (React.ReactElement | typeof ACTION_SEPARATOR)[] = [
      <ReportSearchInput
        placeholder={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.TimeReportingProject.SearchTimeReportingProject
        )}
        key={FormFieldConstants.TimeReportingProject.Filter.ProjectName}
      />,
      ACTION_SEPARATOR,
    ];

    if (timeReportingProjectService.hasCreatePermissions()) {
      buttons = [
        ...buttons,
        <StyledButton size="sm" onClick={onTimeReportingProjectsCreateClick}>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.TimeReportingProject.CreateTimeReportingProject
          )}
        </StyledButton>,
        ACTION_SEPARATOR,
      ];
    }
    buttons = [...buttons, <FilterButton />];

    return buttons;
  };

  return (
    <SearchContextProvider>
      <PageLayouts.DashboardLayout<TimeReportingProjectFormTypes.Filter>
        entityKey={0}
        hasPermissions={CompanyService.isTimeReportingEnabled()}
        title={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.TimeReportingProject.TimeReportingProjects
        )}
        filterFields={reportFilterDefinition}
        topRightButtons={<DashboardButtonGroup buttons={getTopRightButtons()} />}
        filterQueryStateHandler={filterQueryStateHandler}
        filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.TimeReportingProject}
        initialFilter={{ period: DateHelper.getFirstDayOfPreviousMonth(new Date()) }}
        reportToAPIFilterFormatter={timeReportingProjectService.reportToAPIFilter}
        apiToReportFilterFormatter={apiToReportFilterFormatter}
      >
        <Grid container item>
          <TimeReportingProjectsList />
        </Grid>
      </PageLayouts.DashboardLayout>
    </SearchContextProvider>
  );
};

export default TimeReportingProjectReport;
